import React, { Component } from 'react';
import { Rect, Group } from 'react-konva';

export class DayVerticalTimesheetComponentCanvas extends Component {
    render() {
        const { geometry, component, isSelected, dimentionsRatio, draggable } = this.props;

        const geometryWidthRatio = geometry.width / 400.0;
        const geometryHeightRatio = geometry.height / 1050.0;

        const smallHeight = 50 * geometryHeightRatio * dimentionsRatio;
        const smallWidth = 50 * geometryWidthRatio * dimentionsRatio;
        const bigWidth = 200 * geometryWidthRatio * dimentionsRatio;

        const elementsPosX = geometry.drawPositionX + 50 * geometryWidthRatio * dimentionsRatio;
        let rowPosY;

        const componentSecundaryColor = "#EBF5FA";
        const geometryWidth = geometry.width * dimentionsRatio;
        const geometryHeight = geometry.height * dimentionsRatio;

        const rowElements = [];
        let i;
        for (i = 0; i < 10; i++) {
            rowPosY = smallHeight + geometry.drawPositionY + (100 * i) * geometryHeightRatio * dimentionsRatio;

            rowElements.push(
                <Group key={i}>
                    <Rect
                        x={elementsPosX}
                        y={rowPosY}
                        width={smallWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor}
                    />

                    <Rect
                        x={elementsPosX + smallWidth + 50 * geometryWidthRatio * dimentionsRatio}
                        y={rowPosY}
                        width={bigWidth}
                        height={smallHeight}
                        strokeWidth={1}
                        stroke="black"
                        fill={componentSecundaryColor}
                    />
                </Group>
            );
        }

        return (
            <Group
                offsetX={geometry.offsetX}
                offsetY={geometry.offsetY}
                draggable={draggable}
                onDragEnd={this.props.onDragEnd}
                onClick={this.props.onComponentClick ? () => this.props.onComponentClick(component.internalId) : null} >
                <Rect x={geometry.drawPositionX}
                    y={geometry.drawPositionY}
                    width={geometryWidth}
                    height={geometryHeight}
                    strokeWidth={isSelected ? 3 : 1}
                    stroke={isSelected ? "#6699ff" : "black"}
                    fill={component.color} />

                <Group>
                    {rowElements}
                </Group>
            </Group>
        );
    }
}
